import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserService } from '../service/user.service';
import { MasterOperationService } from '../../master/services/master-operation.service';
import { UserRouteModule } from '../user-route/user-route.module';
import { RoleMasterService } from '../../master/services/role-master.service';
import { SpecializeMasterService } from '../../master/services/specialize-master.service';
import { ClinicMasterService } from '../../master/services/clinic-master.service';
import { OrganizationMasterService } from '../../master/services/organization-master.service';
 import { ContactUsService } from '../service/contact-us.service';
import { FormsModule } from '@angular/forms';

@NgModule({
   imports: [
    CommonModule,
    FormsModule,
    UserRouteModule 
  ],
  declarations: [],
  providers : [
    MasterOperationService,UserService,SpecializeMasterService,RoleMasterService, OrganizationMasterService,ClinicMasterService
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class UserModule { }



// WEBPACK FOOTER //
// ./src/app/section/user/user-module/user.module.ts